import { render, staticRenderFns } from "./CreateCompanyForm.vue?vue&type=template&id=05c17f26&scoped=true"
import script from "./CreateCompanyForm.vue?vue&type=script&lang=js"
export * from "./CreateCompanyForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c17f26",
  null
  
)

export default component.exports